import React from "react"
import PathConstants from "./PathConstants"

const DASHBOARD = React.lazy(() => import("../pages/Dashboard"))
const HOME = React.lazy(() => import("../pages/Home"))
const FEATURE = React.lazy(() => import("../pages/Feature"))
const PRICING = React.lazy(() => import("../pages/Pricing"))
const LOGIN = React.lazy(() => import("../pages/Login"))
const SIGNUP = React.lazy(() => import("../pages/Signup"))
const TermsAndConditions = React.lazy(() => import("../pages/TermsAndCondition"))
const PrivacyPolicy = React.lazy(() => import("../pages/PrivacyPolicy"))
const CONTACT = React.lazy(() => import("../pages/Contact"))
const FORGOTPASSWORD = React.lazy(() => import("../pages/ForgotPassword"))
const EDITENDPOINT = React.lazy(() => import("../pages/EditEndPoint"))
const NEWENDPOINT = React.lazy(() => import("../pages/NewEndPoint"))
const VIEWREQUEST = React.lazy(() => import("../pages/ViewRequest"))
const EXAMPLEFORM= React.lazy(() => import("../pages/ExampleForm"))

const routes = [
    { path: PathConstants.HOME, element: <HOME/> },
    { path: PathConstants.DASHBOARD, element: <DASHBOARD /> },
    { path: PathConstants.FEATURE, element: <FEATURE /> },
    { path: PathConstants.PRICING, element: <PRICING /> },
    { path: PathConstants.LOGIN, element: <LOGIN /> },
    { path: PathConstants.SIGNUP, element: <SIGNUP /> },
    { path: PathConstants.TERMSANDCONDITIONS, element: <TermsAndConditions /> },
    { path: PathConstants.PRIVACYPOLICY, element: <PrivacyPolicy /> },
    { path: PathConstants.CONTACT, element: <CONTACT /> },
    { path: PathConstants.FORGOTPASSWORD, element: <FORGOTPASSWORD /> },
    { path: PathConstants.EDITENDPOINT, element: <EDITENDPOINT /> },
    { path: PathConstants.VIEWREQUEST, element: <VIEWREQUEST /> },
    { path: PathConstants.NEWENDPOINT, element: <NEWENDPOINT /> },
    { path: PathConstants.FORMEXAMPLE, element: <EXAMPLEFORM /> },

]
export default routes
